import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box, Button, TextField, Typography, Paper, Container, Alert, CircularProgress
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';
import axios from 'axios';
import logoPainel from '../imagens/logopainelftm.png.ico';

const PageContainer = styled(Container)(({ theme }) => ({
  minHeight: '100vh',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: theme.palette.background.default,
}));

const StyledPaper = styled(Paper)(({ theme }) => ({
  background: 'rgba(17, 24, 39, 0.7)',
  backdropFilter: 'blur(10px)',
  padding: theme.spacing(4),
  borderRadius: '16px',
  border: '1px solid rgba(124, 58, 237, 0.2)',
  maxWidth: '400px',
  width: '100%',
  margin: 'auto',
}));

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/auth/forgot-password`,
        { email },
        { timeout: 15000 }
      );
      if (res.data.success) {
        setSuccess(true);
      } else {
        setError(res.data.message || 'Erro ao enviar email.');
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Erro ao conectar com o servidor.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <PageContainer>
      <StyledPaper elevation={3}>
        <Box sx={{ textAlign: 'center', mb: 3 }}>
          <img src={logoPainel} alt="Painel FTM" style={{ width: 64, height: 64, borderRadius: 12 }} />
        </Box>
        <Typography variant="h5" sx={{ color: '#fff', textAlign: 'center', mb: 1 }}>
          Recuperar Senha
        </Typography>
        <Typography sx={{ color: '#9CA3AF', textAlign: 'center', mb: 3, fontSize: '0.9rem' }}>
          Informe seu email e enviaremos um link para redefinir sua senha.
        </Typography>

        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

        {success ? (
          <Box sx={{ textAlign: 'center' }}>
            <Alert severity="success" sx={{ mb: 3 }}>
              Email enviado! Verifique sua caixa de entrada (e o spam) para o link de recuperação.
            </Alert>
            <Button
              variant="contained" onClick={() => navigate('/login')}
              sx={{
                background: 'linear-gradient(135deg, #7C3AED 0%, #4B1FA6 100%)',
                borderRadius: '12px', textTransform: 'none', fontWeight: 600, px: 4,
                '&:hover': { background: 'linear-gradient(135deg, #8B5CF6 0%, #5B21B6 100%)' }
              }}
            >
              Voltar ao Login
            </Button>
          </Box>
        ) : (
          <form onSubmit={handleSubmit}>
            <TextField
              fullWidth label="Email" type="email" value={email}
              onChange={(e) => setEmail(e.target.value)} margin="normal" required
            />
            <Button
              type="submit" fullWidth variant="contained" disabled={loading}
              sx={{
                mt: 3, mb: 2, background: 'linear-gradient(135deg, #7C3AED 0%, #4B1FA6 100%)',
                color: '#fff', padding: '12px', borderRadius: '12px', textTransform: 'none',
                fontSize: '1rem', fontWeight: 600,
                '&:hover': { background: 'linear-gradient(135deg, #8B5CF6 0%, #5B21B6 100%)' }
              }}
              startIcon={loading ? <CircularProgress size={20} sx={{ color: '#fff' }} /> : null}
            >
              {loading ? 'Enviando...' : 'Enviar Link de Recuperação'}
            </Button>
          </form>
        )}

        <Box sx={{ textAlign: 'center', mt: 1 }}>
          <Button
            variant="text" startIcon={<ArrowBackIcon />}
            onClick={() => navigate('/login')}
            sx={{ color: '#9CA3AF', textTransform: 'none', '&:hover': { color: '#A78BFA' } }}
          >
            Voltar ao login
          </Button>
        </Box>
      </StyledPaper>
    </PageContainer>
  );
}
